package com.bikompanion.ui.strings

val DeBikompanionStrings = object : BikompanionStrings {
    override val actionRetry = "Erneut versuchen"
    override val actionClose = "Schließen"
    override val actionSubmit = "Senden"
    override val detailsLabel = "Details"
    override val detailsShow = "Details anzeigen"
    override val detailsHide = "Details ausblenden"
    override val actionGetDirections = "Route anzeigen"
    override val actionShareStation = "Station teilen"
    override val linkCopied = "Link kopiert"
    override val locateShow = "Meinen Standort anzeigen"
    override val locateFollowHeading = "Meiner Blickrichtung folgen"
    override val locateStopFollowing = "Nicht mehr folgen"
    override val settingsTitle = "Einstellungen"
    override val actionBack = "Zurück"
    override val settingsAppearance = "Darstellung"
    override val settingsLanguage = "Sprache"
    override val languageSystem = "Systemstandard"
    override val themeSystem = "System"
    override val themeLight = "Hell"
    override val themeDark = "Dunkel"
    override val settingsNotifications = "Benachrichtigungen"
    override val stationAlerts = "Stationsbenachrichtigungen"
    override val notificationsOn = "An: Du erfährst, sobald eine beobachtete Station ein Rad hat"
    override val notificationsOff = "Aus: Beobachtete Stationen können dich nicht benachrichtigen"
    override val notificationsBlocked = "Blockiert: Erlaube Benachrichtigungen in den Website-Einstellungen deines Browsers"
    override val actionManage = "Verwalten"
    override val actionTurnOn = "Einschalten"
    override val settingsSupport = "Support"
    override val sendFeedback = "Feedback senden"
    override val sendFeedbackDescription = "Melde ein Problem oder falsche Stationsdaten"
    override val shareApp = "App teilen"
    override val settingsAbout = "Info"
    override val aboutApp = "Über Bikompanion"
    override val aboutDevelopedBy = "Entwickelt von Tiago Araujo"
    override val aboutDataSources = "Datenquellen"
    override val sourceCityBikesDescription = "Bikesharing-Netze weltweit"
    override val sourceGbfsTitle = "GBFS-Feeds der Betreiber"
    override val sourceGbfsDescription = "Live-Stationsdaten der Bikesharing-Betreiber"
    override val sourceOsmTitle = "OpenStreetMap-Mitwirkende"
    override val sourceOsmDescription = "Fahrradparkplätze und Kartendaten"
    override val sourceCartoDescription = "Kartenkacheln"
    override val aboutLegal = "Rechtliches"
    override val licensesTitle = "Open-Source-Lizenzen"
    override val privacyPolicy = "Datenschutzerklärung"
    override val deleteRatings = "Meine Bewertungen löschen"
    override val deleteRatingsDescription = "Schickt uns deine anonyme ID per E-Mail, damit wir sie löschen"
    override val licensesLoadFailed = "Die Lizenzliste konnte nicht geladen werden"
    override val aboutVersion = { version: String -> "Version $version" }
    override val issueFlatTire = "Platter Reifen"
    override val issueFrontBrake = "Vorderbremse funktioniert nicht"
    override val issueRearBrake = "Hinterbremse funktioniert nicht"
    override val issueChain = "Kette rutscht"
    override val issueGears = "Gangschaltung funktioniert nicht"
    override val issueSeat = "Sattel beschädigt oder fehlt"
    override val issueLights = "Licht funktioniert nicht"
    override val issueLockOrBasket = "Schloss oder Korb beschädigt"
    override val issueFrame = "Rahmen beschädigt"
    override val issueMotor = "Elektromotor funktioniert nicht"
    override val issueBattery = "Akku lädt nicht"
    override val issueOther = "Sonstiges"
    override val networksLoadFailed = "Fahrradnetze konnten nicht geladen werden. Prüfe deine Verbindung."
    override val parkingLoadFailed = "Fahrradparkplätze konnten nicht geladen werden"
    override val parkingLoading = "Fahrradparkplätze werden gesucht…"
    override val stationsLoading = "Stationen werden geladen…"
    override val noNetworkHereTitle = "Hier gibt es kein Bikesharing"
    override val noNetworkHereHint = "Zoom heraus, um das nächste Netz zu finden"
    override val installTitle = "Bikompanion installieren"
    override val installHintIos = "Tippe auf Teilen und dann auf Zum Home-Bildschirm."
    override val installHintAndroid = "Hol dir die App bei Google Play."
    override val actionInstall = "Installieren"
    override val parkingTypeStands = "Fahrradständer"
    override val parkingTypeShed = "Fahrradunterstand"
    override val parkingTypeLockers = "Fahrradboxen"
    override val parkingTypeBuilding = "Fahrradparkhaus"
    override val parkingTypeOther = "Fahrradparkplatz"
    override val fieldAddress = "Adresse"
    override val fieldCovered = "Überdacht"
    override val fieldYes = "Ja"
    override val fieldNo = "Nein"
    override val fieldId = "ID"
    override val fieldStationId = "Stations-ID"
    override val fieldCoordinates = "Koordinaten"
    override val fieldCapacity = "Kapazität"
    override val fieldNetwork = "Netz"
    override val fieldName = "Name"
    override val fieldCity = "Stadt"
    override val fieldCountry = "Land"
    override val fieldCompany = "Unternehmen"
    override val fieldLicense = "Lizenz"
    override val fieldLicenseUrl = "Lizenz-URL"
    override val availabilityBikes = "Räder"
    override val availabilityElectric = "Elektro"
    override val availabilityEmpty = "Frei"
    override val bicingNextPickup = { p0: String -> "Nächste Bicing-Ausleihe in $p0" }
    override val rateTitle = "Rad prüfen oder bewerten"
    override val rateFindingNetworks = "Fahrradnetze in deiner Nähe werden gesucht…"
    override val rateWhatsWrong = "Was stimmt damit nicht?"
    override val rateBikeNumber = "Radnummer"
    override val rateElectricBike = "E-Bike"
    override val rateVoteBad = "Schlecht"
    override val rateVoteGood = "Gut"
    override val rateWhichNetwork = "Zu welchem Netz gehört dieses Rad?"
    override val refreshRateLimited = "Anfragelimit erreicht – neuer Versuch erfolgt automatisch"
    override val refreshFailed = "Aktualisierung fehlgeschlagen"
    override val refreshNextUpdate = { p0: Int -> "Nächste Aktualisierung in $p0 s" }
    override val refreshUpdating = "Wird aktualisiert…"
    override val dataNone = "Noch keine Daten"
    override val dataAgeJustNow = "Daten von gerade eben"
    override val dataAgeMinutes = { p0: Int -> "Daten von vor $p0 Min." }
    override val dataAgeHours = { p0: Int -> "Daten von vor $p0 Std." }
    override val dataAgeDays = { p0: Int -> "Daten von vor $p0 Tg." }
    override val actionOpenOperator = { p0: String -> "$p0 öffnen" }
    override val watchNormal = "Normale Räder beobachten"
    override val watchElectric = "E-Bikes beobachten"
    override val watchInstallNormal = "App installieren, um normale Räder zu beobachten"
    override val watchInstallElectric = "App installieren, um E-Bikes zu beobachten"
    override val watchStopNormal = "Normale Räder nicht mehr beobachten"
    override val watchStopElectric = "E-Bikes nicht mehr beobachten"
    override val actionCheckRateBike = "Rad prüfen / bewerten"
    override val layerStations = "Stationen"
    override val layerParking = "Radparken"
    override val mapLabelBikes = { p0: Int -> "$p0 Räder" }
    override val mapLabelEbikes = { p0: Int -> "$p0 E-Bikes" }
    override val mapLabelFree = { p0: Int -> "$p0 frei" }
    override val scoreHeadline = { p0: String, p1: String -> "Rad $p0 · $p1" }
    override val scoreNoRatings = "Noch keine Bewertungen – gib die erste ab."
    override val scoreLooksGood = "Sieht gut aus."
    override val scoreHasProblems = "Andere hatten Probleme mit diesem Rad."
    override val scoreMixed = "Gemischte Bewertungen."
    override val ratingNetworkRequired = "Wähle zuerst das Netz dieses Rads aus."
    override val ratingThanks = { p0: String -> "Danke für deine Bewertung von Rad $p0!" }
    override val ratingCooldown = { p0: Int -> "Du hast dieses Rad vor Kurzem bewertet. Versuche es in $p0 Min. erneut." }
    override val ratingQueued = "Gespeichert – wird gesendet, sobald du wieder online bist."
    override val ratingInvalidBike = "Diese Radnummer ist für dieses Netz nicht gültig."
    override val ratingRejected = "Bewertung konnte nicht gespeichert werden. Bitte versuche es später erneut."
    override val notificationFoundTitle = "Rad verfügbar"
    override val notificationFoundNormal = { p0: String -> "Normales Rad verfügbar bei $p0" }
    override val notificationFoundElectric = { p0: String -> "E-Bike verfügbar bei $p0" }
    override val notificationExpiredTitle = "Stationsbeobachtung beendet"
    override val notificationExpiredNormal = { p0: String -> "Beobachtung normaler Räder bei $p0 nach 30 Minuten beendet" }
    override val notificationExpiredElectric = { p0: String -> "Beobachtung von E-Bikes bei $p0 nach 30 Minuten beendet" }
    override val channelWatchAlertsName = "Stationsbenachrichtigungen"
    override val channelWatchAlertsDescription = "Radverfügbarkeit und Neuigkeiten zu beobachteten Stationen"
    override val channelBackgroundWatchName = "Stationsbeobachtung im Hintergrund"
    override val notificationWatchingTitle = "Fahrradstationen werden beobachtet"
    override val notificationWatchingText = "Ausgewählte Stationen werden im Hintergrund beobachtet"
    override val scoreFewRatings = { count: Int ->
        singularOrPlural(
            count,
            "Bisher nur $count Bewertung.",
            "Bisher nur $count Bewertungen.",
        )
    }
    override val scorePositiveRides = { percent: Int, count: Int ->
        singularOrPlural(
            count,
            "$percent% positiv bei $count Fahrt",
            "$percent% positiv bei den letzten $count Fahrten",
        )
    }
}
